import type { BestOfferInfo, SizeStyles, Layout } from './store-card.types';

interface StoreCardInfoProps {
  name: string;
  bestMenuText: string;
  timeLabel: string;
  pickupTimeText: string;
  distance?: string;
  priceInfo: BestOfferInfo | null;
  sizeStyles: SizeStyles;
  layout: Layout;
}

export function StoreCardInfo({
  name,
  bestMenuText,
  timeLabel,
  pickupTimeText,
  distance,
  priceInfo,
  sizeStyles,
  layout
}: StoreCardInfoProps) {
  if (layout === 'horizontal') {
    return (
      <div className="flex-1 p-3 space-y-1">
        <h3 style={{ fontSize: sizeStyles.titleSize }} className="font-bold text-[#222222]">
          {name}
        </h3>
        <p style={{ fontSize: sizeStyles.descSize }} className="text-[#222222]">
          {bestMenuText}
        </p>
        <p style={{ fontSize: sizeStyles.descSize }} className="text-[#222222]">
          {timeLabel}: {pickupTimeText}
        </p>
        <div className="flex items-center justify-between">
          {/* 왼쪽: 거리 정보 */}
          {distance && (
            <span className="text-[12px] text-[#666666]">
              {distance}
            </span>
          )}
          
          {/* 오른쪽: 할인율과 가격 */}
          <PriceDisplay priceInfo={priceInfo} sizeStyles={sizeStyles} />
        </div>
      </div>
    );
  }

  return (
    <div 
      className="bg-white w-full flex flex-col justify-start box-border flex-grow"
      style={{ 
        minHeight: '110px',
        padding: '12px',
        borderRadius: '0 0 10px 10px',
        gap: '12px'
      }}
    >
      {/* 대표메뉴 */}
      <p className="text-[14px] min-[376px]:text-[16px] text-[#222222] font-normal truncate max-w-full" style={{ lineHeight: '1.1', margin: '0' }}>
        {bestMenuText}
      </p>

      {/* 수령가능시간/영업시간 */}
      <p className="text-[14px] min-[376px]:text-[16px] text-[#222222] font-normal truncate max-w-full" style={{ lineHeight: '1.1', margin: '0' }}>
        {timeLabel}: {pickupTimeText}
      </p>

      {/* 거리, 할인율과 가격 */}
      <div className="flex items-center justify-between mt-auto" style={{ margin: '0' }}>
        {/* 왼쪽: 거리 정보 */}
        {distance && (
          <span className="text-[14px] text-[#666666]">
            {distance}
          </span>
        )}
        
        {/* 오른쪽: 할인율과 가격 */}
        <PriceDisplay priceInfo={priceInfo} sizeStyles={sizeStyles} isVertical />
      </div>
    </div>
  );
}

interface PriceDisplayProps {
  priceInfo: BestOfferInfo | null;
  sizeStyles: SizeStyles;
  isVertical?: boolean;
}

function PriceDisplay({ priceInfo, sizeStyles, isVertical = false }: PriceDisplayProps) {
  const priceSize = isVertical ? '20px' : sizeStyles.priceSize;
  
  return (
    <div className="flex items-center ml-auto" style={{ gap: '4px' }}>
      {priceInfo && priceInfo.discountRate > 0 && (
        <>
          <span className="text-[14px] font-medium text-[#FF3B30]">
            (-{priceInfo.discountRate}%)
          </span>
          <span 
            className={isVertical ? "text-[#4CD964]" : "text-[#3AA53F]"}
            style={{ fontSize: priceSize, fontWeight: '600' }}
          >
            {priceInfo.discountedPrice.toLocaleString()}원 ~
          </span>
        </>
      )}
      {priceInfo && priceInfo.discountRate === 0 && (
        <span 
          className={isVertical ? "text-[#4CD964]" : "text-[#3AA53F]"}
          style={{ fontSize: priceSize, fontWeight: '600' }}
        >
          {priceInfo.originalPrice.toLocaleString()}원 ~
        </span>
      )}
    </div>
  );
}